import {WithResources} from '@freckle/classroom/ts/common/components/with-resources'
import {useTeacher} from '@freckle/classroom/ts/hooks/use-teacher'
import {QuoteRequestModal as Modal} from './quote-request-modal'

type Props = {
  show: boolean
  onHide: () => void
}

export const QuoteRequestModal = (props: Props) => {
  const teacher = useTeacher()

  return (
    <WithResources
      resources={{teacher}}
      render={({teacher}) => <Modal teacher={teacher} {...props} />}
    />
  )
}
